import axios from "axios";
import { trackReachability } from "./utility/offline/reachability";



// Base axios instance

const axiosInstance = axios.create({

  baseURL: "https://01pos2.01technologies.net/", // API Base URL

});



// Request interceptor for Superadmin

axiosInstance.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("superadmin_token");

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// Create an Axios instance for Admin

const adminAxios = axios.create({

  baseURL: "https://01pos2.01technologies.net/api/admin/", // API Base URL (same as general)

});



adminAxios.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("admin_token"); // Get admin token

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



const adminAxiosv3 = axios.create({

  baseURL: "https://01pos2.01technologies.net/api/v3/admin/", // API Base URL (same as general)

});



adminAxiosv3.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("admin_token"); // Get admin token

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// Create an Axios instance for Manager

const managerAxios = axios.create({

  baseURL: "https://01pos2.01technologies.net/api/managers/", // API Base URL (same as general)

});



managerAxios.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("manager_token"); // Get manager token

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// Create an Axios instance for Cashier

const cashierAxios = axios.create({

  baseURL: "https://01pos2.01technologies.net/api/cashiers/", // API Base URL (same as general)

  timeout: 10000, // fail fast on wifi with no internet instead of the ~35s OS timeout

});

trackReachability(cashierAxios);



cashierAxios.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("cashier_token"); // Get cashier token

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



const supervisorAxios = axios.create({

  baseURL: "https://01pos2.01technologies.net/api/supervisors/", // API Base URL (same as general)

});



supervisorAxios.interceptors.request.use(

  (config) => {

    const token = sessionStorage.getItem("supervisor_token"); // Get cashier token

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// Export all axios instances

export {

  axiosInstance,

  adminAxios,

  adminAxiosv3,

  managerAxios,

  cashierAxios,

  supervisorAxios,

};
